import React, { useEffect, useState } from "react";
import { Card, Row, Col, message, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

import useRateLimitEvents from "hooks/rate-limits/useRateLimitEvents";
import RateLimitEventsTable from "./RateLimitEventsTable";
import RateLimitEventDrawer from "./RateLimitEventDrawer";
import RateLimitFilters from "./RateLimitFilters";

const RateLimitEventsPage = () => {

  const [filters, setFilters] = useState({});
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const {
    events,
    loading,
    totalElements,
    pagination,
    setPagination,
    fetchAllEvents
  } = useRateLimitEvents();



  useEffect(() => {
    fetchAllEvents({});
  }, []);

  // filtering
  const handleSearch = (filterValues) => {

    setFilters(filterValues);
    setPagination({
      current: 1
    });

    fetchAllEvents(filterValues).catch(() => {
      message.error("Failed to fetch rate limit events");
    });

  };


  const handleViewDetails = (record) => {
    setSelectedEvent(record);
    setDrawerOpen(true);
  };

  // pagination
  const handlePageChange = (pager) => {
    setPagination({
      current: pager.current,
      pageSize: pager.pageSize
    });
  };


  return (

    <div className="rate-limit-events-page">

      <Row gutter={[16, 16]}>

        {/* Filters */}

        <Col span={24}>
          <Card title="Rate Limit Filters">

            <RateLimitFilters
              onSearch={handleSearch}
            />

          </Card>
        </Col>

        {/* Events Table */}

        <Col span={24}>
            <Card title="Rate Limit Events" extra={
                <Button
                    icon={<ReloadOutlined />}
                    loading={loading}
                    onClick={() => fetchAllEvents()}
                >
                    Refresh
                </Button>
            }>

                <RateLimitEventsTable
                    data={events}
                    loading={loading}
                    totalElements={totalElements}
                    pagination={pagination}
                    onViewDetails={handleViewDetails}
                    onPageChange={handlePageChange}
                />

            </Card>
        </Col>

      </Row>

      {/* Drawer */}

      <RateLimitEventDrawer
        open={drawerOpen}
        event={selectedEvent}
        onClose={() => setDrawerOpen(false)}
      />

    </div>

  );

};

export default RateLimitEventsPage;